import { useEffect, useState } from 'react';

// A number that goes up when the app comes back to the screen after being
// hidden for at least `minHiddenMs` (a phone locked or the app in the
// background). Firestore listeners can stall while a page is hidden (iOS
// especially) and keep showing old data, so effects that set up listeners
// list this key among their dependencies to start fresh ones.
export function useResumeKey(minHiddenMs = 30000) {
    const [ key, setKey ] = useState(0);

    useEffect(() => {
        let hiddenAt = document.hidden ? Date.now() : null;
        const onChange = () => {
            if (document.hidden) {
                hiddenAt = Date.now();
            } else if (hiddenAt !== null) {
                if (Date.now() - hiddenAt >= minHiddenMs) setKey(k => k + 1);
                hiddenAt = null;
            }
        };
        document.addEventListener('visibilitychange', onChange);
        return () => document.removeEventListener('visibilitychange', onChange);
    }, [minHiddenMs])

    return key;
}
